import React from "react";
import "./index.scss";
const CustomCard = ({ children }) => {
  return <div className="custom-card-con">{children}</div>;
};

export default CustomCard;
